import { Button, Form } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { handleOptions } from '..';
import { ConditionalOptionType, ConditionalType, DataField } from '../..';
import { generateUniqueId } from '../../../../utils/dateFormat';
import { FormLabelCustom } from '../../styles';
import { FieldOptions } from './FieldOptions';

export type UpdateCondicionalField = {
  value?: string
  fieldName?: string
  conditionalIndex: number
  conditionalOptionIndex: number
  fieldIndex: number 
}
export type CondicionalCheckbox = {
  value: number
  conditionalIndex: number
  conditionalOptionIndex: number
}

export type handleOptionsInFields = {
  conditionalIndex: number
  conditionalOptionIndex: number
  fieldIndex: number 
  fieldOptionIndex?: number
  fieldOptionValue?: string
  fieldName?: string
}

interface FormConditionalProps {
  formData: DataField
  setFormData: (value: React.SetStateAction<DataField>) => void  
  conditional: ConditionalType
  conditionalIndex: number
  conditionalOption: ConditionalOptionType
  conditionalOptionIndex: number
  isEmptyField: (fieldName: string) => boolean
  removesFieldFromTheEmptyFields: ({ fieldName, removeField }: {
    fieldName: string;
    removeField?: boolean;
}) => void
}

export function FormConditional({
  formData,
  setFormData,
  conditional,
  conditionalIndex,
  conditionalOption,
  conditionalOptionIndex,
  isEmptyField,
  removesFieldFromTheEmptyFields
}: FormConditionalProps){


  // ----> Função para permitir a duplicação dos campos no workspace
  // const handleCheckbox = ({ value, conditionalIndex, conditionalOptionIndex}: CondicionalCheckbox) => {
  // setFormData(state => {
  //   let conditional = [...state.condicional_campos];
  //   let options = [...conditional[conditionalIndex].opcoes]

  //   options[conditionalOptionIndex] = {
  //     ...options[conditionalOptionIndex],
  //     duplicar_campos: value
  //   }

  //   conditional[conditionalIndex] = {
  //     ...conditional[conditionalIndex],
  //     opcoes: options
  //   }

  //   return { ...state, condicional_campos: conditional };
  // });
  // }

  const handleUpdateFieldInConditionalOptionList =  ({ 
    value,
    fieldName,
    conditionalIndex, 
    conditionalOptionIndex, 
    fieldIndex
  }: UpdateCondicionalField) => {
    setFormData(state => {
      let conditional = [...state.condicional_campos];
      let options = [...conditional[conditionalIndex].opcoes]

      options[conditionalOptionIndex] = {
        ...options[conditionalOptionIndex],
        lista_campos: options[conditionalOptionIndex].lista_campos.map((item, i) => {
          return  i === fieldIndex ? { ...item, [fieldName]: value } : item
        }),
      }

      conditional[conditionalIndex] = {
        ...conditional[conditionalIndex],
        opcoes: options
      }

      return { ...state, condicional_campos: conditional };
    });

   };

  const handleUpdateFormSelectInConditionalOptionList =  ({ value, conditionalIndex, conditionalOptionIndex, fieldIndex}: UpdateCondicionalField) => {
    const isSelect = value === 'Select' || value === 'Radio button'

    if(isSelect){
      setFormData(state => {
        let conditional = [...state.condicional_campos];
        let options = [...conditional[conditionalIndex].opcoes]

        options[conditionalOptionIndex] = {
          ...options[conditionalOptionIndex],
          lista_campos: options[conditionalOptionIndex].lista_campos.map((item, i) => {
            const newOptionsToSelect = [{ id: generateUniqueId(), resposta: '', texto_ajuda: '' }]
            const option = (item.opcoes && item.opcoes.length > 0) ? [...item.opcoes] : [...newOptionsToSelect, ]

            return  i === fieldIndex ? { ...item, tipo: value, opcoes: option } : item
          }),
        }

        conditional[conditionalIndex] = {
          ...conditional[conditionalIndex],
          opcoes: options
        }
  
        return { ...state, condicional_campos: conditional };
      });

    } else {
      setFormData(state => {
        let conditional = [...state.condicional_campos];
        let options = [...conditional[conditionalIndex].opcoes]

        options[conditionalOptionIndex] = {
          ...options[conditionalOptionIndex],
          lista_campos: options[conditionalOptionIndex].lista_campos.map((item, i) => {
            return  i === fieldIndex ? { ...item, tipo: value, opcoes: [] } : item
          }),
        }

        conditional[conditionalIndex] = {
          ...conditional[conditionalIndex],
          opcoes: options
        }
  
  
        return { ...state, condicional_campos: conditional };
      });

    }

  };

  const handleRemoveFieldInConditionalOptions = ({ conditionalIndex, conditionalOptionIndex, fieldIndex}: UpdateCondicionalField) => {
    let newFormData = { ...formData };
    let conditionalToUpdate = newFormData.condicional_campos[conditionalIndex];
    let options = conditionalToUpdate.opcoes;
    let fields = options[conditionalOptionIndex].lista_campos.filter((_, i) => i !== fieldIndex);

    options[conditionalOptionIndex] = {
      ...options[conditionalOptionIndex],
      duplicar_campos:  options[conditionalOptionIndex].duplicar_campos === 0 ? 0 : fields.length,
      lista_campos: fields
    }

    conditionalToUpdate = {
      ...conditionalToUpdate,
      opcoes: options
      
    };

    newFormData.condicional_campos[conditionalIndex] = conditionalToUpdate;

    setFormData(newFormData);
   }

   const handleAddNewFieldInConditionalOptions = ({ conditionalIndex, conditionalOptionIndex }: handleOptions) => {
    let data = {...formData};
    let conditional = data.condicional_campos[conditionalIndex]
    let options = conditional.opcoes;

    
    const newField = {
      id: generateUniqueId(),
      nome: '',
      resposta: '',
      tipo: 'Texto',
      texto_ajuda: '',
      opcoes: []
    };

    const listOfFields =  [
      ...options[conditionalOptionIndex].lista_campos,
      newField
    ]

    options[conditionalOptionIndex] = {
      ...options[conditionalOptionIndex],
      duplicar_campos:  options[conditionalOptionIndex].duplicar_campos === 0 ? 0 : listOfFields.length,
      lista_campos: listOfFields
    }

    conditional = {
      ...conditional,
      opcoes: options
    }
  
    data.condicional_campos[conditionalIndex] = conditional
    setFormData(data);
  };


  const handleAddNewOptionInConditionalField = ({conditionalIndex, conditionalOptionIndex, fieldIndex}: handleOptionsInFields) => {
    let newFormData = { ...formData };
    let conditionalToUpdate = newFormData.condicional_campos[conditionalIndex];
    let optionsToUpdate = conditionalToUpdate.opcoes;
    let fieldsToUpdate = optionsToUpdate[conditionalOptionIndex].lista_campos;
    let fieldToUpdate = { ...fieldsToUpdate[fieldIndex] };
    let optionsFieldToUpdate = fieldToUpdate.opcoes;

    const newOptionToField = {
      id: generateUniqueId(),
      resposta: '',
      texto_ajuda: '',
    };

    const updatedField = {
      ...fieldToUpdate,
      opcoes: [...optionsFieldToUpdate, newOptionToField],
    };

    const updatedFields = [...fieldsToUpdate.slice(0, fieldIndex), updatedField, ...fieldsToUpdate.slice(fieldIndex + 1)];
    optionsToUpdate[conditionalOptionIndex] = {
      ...optionsToUpdate[conditionalOptionIndex],
      lista_campos: updatedFields,
    };

    conditionalToUpdate.opcoes = optionsToUpdate;
    conditionalToUpdate.opcoes[conditionalOptionIndex].lista_campos = updatedFields;

    newFormData.condicional_campos[conditionalIndex] = conditionalToUpdate;

    setFormData(newFormData);
  }

  return (
    <>
      {conditionalOption.lista_campos && conditionalOption.lista_campos.length > 0 && (
        <div className="mt-4 pt-2 col-md-12 col-sm-12">
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
              <h2 className="fw-bold fs-5">{conditionalOptionIndex + 1} - Formulário:</h2>
              <span>{conditional.opcoes[conditionalOptionIndex].resposta }</span>
            </div>
            <p className='mb-4'>
              Este formulário será apresentado caso o usuário escolha a opção {conditionalOptionIndex + 1}.
            </p>     
            {conditionalOption.lista_campos.map((field, fieldIndex) => (
                <div key={field.id}>
                  <div className='row' >
                  <Form.Group
                    style={{ maxWidth: 80}}
                    className="mb-3 col-md-2">
                    <FormLabelCustom>Ordem</FormLabelCustom>
                    <Form.Control
                      placeholder="Ordem"
                      readOnly
                      style={{ maxWidth: 38, aspectRatio: '1'}}
                      value={fieldIndex  + 1}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-4">
                    <FormLabelCustom required>Nome</FormLabelCustom>
                    <Form.Control
                      placeholder="Digite o Nome"
                      value={field.nome}
                      isInvalid={isEmptyField(`field.nome.${field.id}`)}
                      required
                      onChange={(event) => {
                        handleUpdateFieldInConditionalOptionList({
                          value: event.target.value,
                          fieldName: 'nome',
                          conditionalIndex,
                          conditionalOptionIndex,
                          fieldIndex,
                        });
                        removesFieldFromTheEmptyFields({
                          fieldName: `field.nome.${field.id}`, 
                          removeField: !!event.target.value
                        })
                      }}
                    />
                    {isEmptyField(`field.nome.${field.id}`) && 
                      <Form.Control.Feedback type="invalid">
                        Campo obrigatório
                      </Form.Control.Feedback>
                    }
                  </Form.Group>

                    <Form.Group className="col-md-3">
                      <FormLabelCustom required>Escolha o tipo de Campo</FormLabelCustom>
                      <Form.Select
                        placeholder='Selecione'
                        value={field.tipo}
                        isInvalid={!field.tipo}
                        required
                        onChange={(event) => {
                          handleUpdateFormSelectInConditionalOptionList({
                            value: event.target.value,
                            conditionalIndex,
                            conditionalOptionIndex,
                            fieldIndex,
                          })
                        }}
                      >
                        <option value="Texto">Texto</option>
                        <option value="Numero">Número</option>
                        <option value="Data">Data</option>
                        <option value="Area">Area</option>
                        <option value="Email">Email</option>
                        <option value="Telefone">Telefone</option>
                        <option value="Select">Select</option>
                        <option value="Radio button">Radio button</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3 col-md-3">
                    <FormLabelCustom required>Texto de ajuda</FormLabelCustom>
                    <Form.Control
                      placeholder="Digite o texto de ajuda"
                      value={field.texto_ajuda}
                      isInvalid={isEmptyField(`field.helper_text.${field.id}`)}
                      required
                      onChange={(event) => {
                        handleUpdateFieldInConditionalOptionList({
                          value: event.target.value,
                          fieldName: 'texto_ajuda',
                          conditionalIndex,
                          conditionalOptionIndex,
                          fieldIndex,
                          
                        });
                        removesFieldFromTheEmptyFields({
                          fieldName: `field.helper_text.${field.id}`, 
                          removeField: !!event.target.value
                        })
                      }}
                    />
                    {isEmptyField(`field.helper_text.${field.id}`) && 
                      <Form.Control.Feedback type="invalid">
                        Campo obrigatório
                      </Form.Control.Feedback>
                    }
                  </Form.Group>
                  {conditionalOption.lista_campos.length > 0 && (
                    <div className='col-md-1 col-sm-12 text-center mt-4 pt-2'>
                      <Button
                        variant="text"
                        className="border"
                        onClick={() => {
                          handleRemoveFieldInConditionalOptions({
                            conditionalIndex, 
                            conditionalOptionIndex,
                            fieldIndex
                          });
                        }}
                      >
                        <FaTrash title="Remover este campo da lista de condicionais"/>
                      </Button>
                    </div>
                  )}
                  </div>
                <div className='row ps-4 mt-3'>
                  {(field.opcoes && field.opcoes.length > 0) && (
                      <div 
                        className="mt-2 mb-3 col-md-12"> 
                          <h3 className="fw-bold fs-6">Lista de opções para o {field.tipo}</h3>
                      </div>
                    )}
                  <FieldOptions
                     field={field}
                     fieldIndex={fieldIndex}
                     formData={formData}
                     setFormData={setFormData}
                     conditionalIndex={conditionalIndex}
                     conditionalOptionIndex={conditionalOptionIndex}
                     isEmptyField={isEmptyField}
                     removesFieldFromTheEmptyFields={removesFieldFromTheEmptyFields}
                  />
                </div>
                {(field.opcoes && !!field.opcoes.length) && (
                    <div className='col-md-12 ps-4 border-bottom border-3 pb-4  my-2 pt-2'>
                      <Button
                        onClick={() => {
                          handleAddNewOptionInConditionalField({
                            conditionalIndex, 
                            conditionalOptionIndex, 
                            fieldIndex,
                          })
                        }}
                      >
                        Adicionar uma nova opção
                      </Button>
                    </div>
                  )}
                </div>
            ))}
             {/* <FormGroup className='mb-2'> ----->  Permite a duplicação do formulário no workspace 
              <FormControlLabel 
                label="O usuário pode duplicar os campos desse formulário." 
                control={
                <Checkbox
                  value={conditionalOption.lista_campos.length}
                  defaultChecked={conditionalOption.duplicar_campos > 0}
                  onClick={(event) => {
                    if (event.target instanceof HTMLInputElement) {
                      handleCheckbox({
                        value: event.target.checked ? conditionalOption.lista_campos.length : 0,
                        conditionalIndex,
                        conditionalOptionIndex,
                      });
                    }
                  }}
                  />} 
              /> 
            </FormGroup> */}
            <Button
            onClick={() => {
              handleAddNewFieldInConditionalOptions({
                conditionalIndex, 
                conditionalOptionIndex
              })
            }}>
                Adicionar um novo campo ao formulário
            </Button>
        </div>
      )}
      {conditionalOption.lista_campos.length === 0 && (
        <Button
        className='mt-2' 
        onClick={() => {
          handleAddNewFieldInConditionalOptions({
            conditionalIndex, 
            conditionalOptionIndex
          })
        }}>
            Adicionar um formulário
        </Button>
      )}
    </>
  )
}